/* eslint-disable */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigService } from '@uxdf/direct-shared-lib';
import Cookies from 'js-cookie';
import { isOn } from 'feature-toggle-service';
import { InvoiceHierarchyItem } from '../reducers/reducers-avc-invoices';
import { InvoiceDownloadAPI } from '../../../../../redux/models/invoices/invoice-download-api';
import { JWT_TYPE_NAME, ReefHeaders, ReefTokenService } from '@seco/core';

@Injectable({
  providedIn: 'root'
})
export class AvcInvoicesService {
  component_url = {
    avcInvoices: () => 'api/amadeus/avc-invoices',
    avcInvoicesNew: officeId => `/aa/api/v1/invoice/${officeId}`,
    avcInvoicesHierarchy: () => `/aa/api/v1/invoice/hierarchy`,
    invoicesConfig: store => 'rest/' + store + '/V1/amadeus/public/invoice/config'
  };

  constructor(private readonly httpClient: HttpClient, private readonly initService: ConfigService, private readonly reefTokenService: ReefTokenService) {}

  getAvcInvoicesWithStatus(officeId?: string): Observable<InvoiceDownloadAPI.IInvoicesResponsesWithStatus | InvoiceDownloadAPI.IInvoiceResponse[]> {
    if (isOn('INVOCING_NETWORK_LEVEL_A')) {
      return this.httpClient.get<InvoiceDownloadAPI.IInvoiceResponse[]>(
        this.avcUrl(this.component_url.avcInvoicesNew(officeId)),
        this.avcHeaders()
      );
    } else {
      return this.httpClient.get<InvoiceDownloadAPI.IInvoicesResponsesWithStatus>(
        `${this.initService.getEnvConfig().AD_JAVA_API_URL}${this.component_url.avcInvoices()}`,
        {
          responseType: 'json'
        }
      );
    }
  }

  getAvcInvoicesHierarchy(): Observable<InvoiceHierarchyItem[]> {
    return this.httpClient.get<InvoiceHierarchyItem[]>(this.avcUrl(this.component_url.avcInvoicesHierarchy()), this.avcHeaders());
  }

  avcUrl(url: string): string {
    const sessionId = localStorage.getItem('JsessionId');
    return `${url};jsessionid=${sessionId}`;
  }

  avcHeaders(): {
     headers?:
       | HttpHeaders
       | {
         [header: string]: string | string[];
       };
       context?: HttpContext;
       observe?: 'body';
       params?:
       | HttpParams
       | {
         [param: string]: string | number | boolean;
       };
       reportProgress?: boolean;
       responseType?: 'json';
       withCredentials?: boolean;
     } {
       const options: any = { withCredentials: true };
       const jwtMap = this.reefTokenService.getTokens();
       const jwt = jwtMap?.get(ReefHeaders.AUTH)?.get(JWT_TYPE_NAME);
         const headers = new HttpHeaders({
           Authorization: `Bearer ${jwt}`
         });
         options.headers = headers;
       return options;
     }
}
